import { useMemo } from "react";
import { textOverflow } from "Utils/Styles";

import { useTheme } from "@fluentui/react/lib/Theme";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  entry: `MergeEntry`,
  entryAlt: `MergeEntryAlt`,
  footer: `MergeFooter`,
  header: `MergeHeader`,
  label: `MergeLabel`,
  origin: `MergeOrigin`,
  root: `MergeRoot`,
  target: `MergeTarget`
};

export function useMergeStyles(externalStyleSet: IStyleSet) {
  const { spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            width: `100%`
          }
        ],
        header: [
          classNames.header,
          {
            height: `32px`,
            padding: `${spacing.m} ${spacing.s1}`,
            marginBottom: spacing.m,
            "& *": {
              fontWeight: 600
            }
          }
        ],
        label: [
          classNames.label,
          {
            width: `150px`,
            ...textOverflow
          }
        ],
        origin: [
          classNames.origin,
          {
            paddingLeft: spacing.l2,
            width: `calc(50% - 5px)`,
            ...textOverflow
          }
        ],
        target: [
          classNames.target,
          {
            paddingLeft: spacing.l2,
            width: `calc(50% - 5px)`,
            ...textOverflow
          }
        ],
        footer: [
          classNames.footer,
          {
            padding: `${spacing.s1} 0 0 0`,
            margin: 0,
            [`& > .${classNames.origin}`]: {
              padding: `0 0 0 65px`
            },
            [`& > .${classNames.target}`]: {
              padding: `0 0 0 20px`
            }
          }
        ]
      },
      externalStyleSet
    ),
    [externalStyleSet, spacing]
  );
}
